__turbopack_context__.v({
  "contact": "style-module-scss-module__z50QDG__contact",
  "contacts": "style-module-scss-module__z50QDG__contacts",
  "container": "style-module-scss-module__z50QDG__container",
  "footer": "style-module-scss-module__z50QDG__footer",
  "phone": "style-module-scss-module__z50QDG__phone",
});
